import { useEffect } from 'react';
import { NEGOCIO, urlAbsoluta, type PaginaSeo } from './datos';

function meta(atributo: 'name' | 'property', clave: string, valor: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${atributo}="${clave}"]`);
  if (!valor) {
    el?.remove();
    return;
  }
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(atributo, clave);
    document.head.appendChild(el);
  }
  el.content = valor;
}

/**
 * Título, descripción, canonical, Open Graph y datos estructurados de la
 * página actual. Reemplaza lo que dejó el HTML pre-renderizado o la página
 * anterior, así Google ve lo correcto también al navegar dentro de la app.
 */
export function useSeo(pagina: PaginaSeo | null) {
  const clave = pagina ? JSON.stringify(pagina) : '';

  useEffect(() => {
    if (!pagina) return;
    const url = urlAbsoluta(pagina.ruta);
    const imagen = pagina.imagen ?? NEGOCIO.imagen;

    document.title = pagina.titulo;
    meta('name', 'description', pagina.descripcion);
    meta('name', 'robots', pagina.noIndex ? 'noindex, follow' : 'index, follow, max-image-preview:large');
    meta('property', 'og:title', pagina.titulo);
    meta('property', 'og:description', pagina.descripcion);
    meta('property', 'og:url', url);
    meta('property', 'og:image', imagen);
    meta('property', 'og:type', pagina.ruta.startsWith('/products/') ? 'product' : 'website');
    meta('name', 'twitter:title', pagina.titulo);
    meta('name', 'twitter:description', pagina.descripcion);
    meta('name', 'twitter:image', imagen);

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = url;

    document.head.querySelectorAll('script[data-seo]').forEach((s) => s.remove());
    for (const datos of pagina.jsonLd) {
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.dataset.seo = '';
      s.textContent = JSON.stringify(datos);
      document.head.appendChild(s);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clave]);
}
